import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "add",
  "use": "add-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"add\"><defs><style></style></defs><path d=\"M512 1024c-31.289 0-56.889-25.6-56.889-56.889V56.89C455.111 25.6 480.711 0 512 0s56.889 25.6 56.889 56.889V967.11c0 31.289-25.6 56.889-56.889 56.889z\" /><path d=\"M0 512c0-31.289 25.6-56.889 56.889-56.889H967.11c31.289 0 56.889 25.6 56.889 56.889s-25.6 56.889-56.889 56.889H56.89C25.6 568.889 0 543.289 0 512z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol